import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Header from "./components/Layout/Header";
import Sidebar from "./components/Layout/Sidebar";
import AuthContextProvider from "./context/AuthContext";
import DataContextProvider from "./context/DataContext";
import FunctionsContextProvider from "./context/FunctionsContext";
import HandleContextProvider from "./context/HandleContext";
import Routes from "./routes/routes";

function App() {
  const theme = createMuiTheme({
    typography: {
      fontFamily: `'Raleway', sans-serif`,
      fontWeightRegular: 500,
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <FunctionsContextProvider>
          <HandleContextProvider>
            <AuthContextProvider>
              <DataContextProvider>
                <Header />
                <div className="d-flex">
                  <Sidebar />
                  <div className="w-100">
                    <Routes />
                  </div>
                </div>
              </DataContextProvider>
            </AuthContextProvider>
          </HandleContextProvider>
        </FunctionsContextProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
